import styled from 'styled-components'

export const Container = styled.div`
	margin: 5px 8px;

	p {
		line-height: 24px;
	}
`
